var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',[_c('v-breadcrumbs',{attrs:{"items":_vm.items}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }